export const PauseOutline = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="13" stroke="currentColor" stroke-width="2"/>
<path d="M19 10V22" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M13 10V22" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
